import React, { cloneElement } from "react";
import { styles } from "./StatsView.styles";
import { WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box/Box";
import Paper from "@material-ui/core/Paper/Paper";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import { IStatsFilterOptionType, IStatsFilters } from "./StatsFilter/StatsFilter";

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`download-centre-tabpanel-${index}`}
            aria-labelledby={`download-centre-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={0}>{children}</Box>}
        </div>
    );
}

export interface IStatsTab {
    title: string;
    filters: IStatsFilterOptionType[];
    view: JSX.Element;
    action?: (params: any) => {};
    actionId?: string;
}

export interface IStatsTabsProps extends WithStyles<typeof styles> {
    tabs: IStatsTab[];
    selectedTab: number;
    from: number;
    to: number;
    filters: IStatsFilters;
    onTabChange: (tab: number) => void;
}

const StatsTabsPure: React.FunctionComponent<IStatsTabsProps> = ({
    classes,
    tabs,
    selectedTab,
    from,
    to,
    filters,
    onTabChange
}: IStatsTabsProps) => {
    return (
        <>
            <Paper square>
                <Tabs value={selectedTab} indicatorColor="primary" textColor="primary" onChange={(e, newValue) => onTabChange(newValue)}>
                    {tabs.map((tab, index) => (
                        <Tab key={index} label={tab.title} />
                    ))}
                </Tabs>
            </Paper>
            {tabs.map((tab, index) => {
                return (
                    <TabPanel value={selectedTab} key={index} index={index}>
                        <div className={classes.statsTab}>
                            {cloneElement(tab.view, { filters, from, to })}
                        </div>
                    </TabPanel>
                );
            })}
        </>
    );
};

export const StatsTabs = withStyles(styles)(StatsTabsPure);
